import Vue from 'vue'
import App from './App'
import router from './router'

import globals from './globals'
import Popper from 'popper.js'
import {
  store
} from './_store'

import BootstrapVue from 'bootstrap-vue'

import VueMoment from 'vue-moment'

/* import DisableAutocomplete from 'vue-disable-autocomplete'; */

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false

/* Vue.config.devtools = true */
console.log(Vue.config)
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VueMoment)
//Vue.use(DisableAutocomplete)

// Global RTL flag
Vue.mixin({
  data: globals
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
